import PropTypes from "prop-types"

import { cn } from "styles/utils"

const ImageLoader = ({ className }) => (
  <div className="absolute inset-0 z-40 flex items-center justify-center">
    <div
      className={cn("animate-morph h-20 w-20", className)}
      data-cy="product-main-slider-main-img-spinning"
    />
  </div>
)

ImageLoader.propTypes = {
  className: PropTypes.string,
}

export default ImageLoader
